import React, { useState } from 'react';
import { connect } from 'react-redux';
import Modal from '../Modal';
import { Form, Radio } from 'antd';
import TEXT from '../Text';
import { ButtonPrimary, ButtonSecondary } from '../Button';
import { TextInput, TextPassword } from '../../components/FormFields';
import { createAdminNewUser } from '../../../redux/actions/adminPanel/adminUsers';
import './style.scss';
import { useTranslation } from "react-i18next";

const AddUserModal = ({ showAddUserModal, setShowAddUserModal, createAdminNewUser, updateUsersList }) => {
  const [isFetching, setIsFetching] = useState(false);
  const [form] = Form.useForm();

  const { t } = useTranslation();

  const handleClose = () => {
    setShowAddUserModal(false);
    form.resetFields();
  };

  return (
    <Modal
      title={t('admin.add_new_user')}
      visible={showAddUserModal}
      width={385}
      footerComponent={
        <div className="add-user-modal__buttons-wrap">
          <ButtonSecondary onClick={handleClose}>{t('admin.cancel')}</ButtonSecondary>
          <ButtonPrimary loading={isFetching} disabled={isFetching} onClick={form.submit}>
            {t('admin.add')}
          </ButtonPrimary>
        </div>
      }
      onCancel={handleClose}
    >
      <div className="add-user-modal">
        <Form
          form={form}
          name="add-user-form"
          autoComplete="off"
          initialValues={{
            email: '',
            password: '',
            roles: 'corporate',
          }}
          onFinish={async values => {
            setIsFetching(true);
            const response = await createAdminNewUser({ ...values, roles: ['corporate'] });
            setIsFetching(false);
            if (response) {
              handleClose();
              updateUsersList();
            }
          }}
        >
          <div className="add-user-modal__input-wrap">
            <TextInput
              name="email"
              label={t('admin.email')}
              placeholder={t('admin.type_email')}
              maxLength={false}
              rules={[{ required: true, message: 'required' }]}
            />
          </div>
          <div className="add-user-modal__input-wrap">
            <TextPassword
              name="password"
              label={t('admin.password')}
              placeholder={t('admin.enter_password')}
              autoComplete="new-password"
              rules={[{ required: true, message: 'required' }]}
            />
          </div>
          <button type="submit" hidden></button>
        </Form>
      </div>
    </Modal>
  );
};

const mapDispatchToProps = {
  createAdminNewUser,
};

export default connect(null, mapDispatchToProps)(AddUserModal);
